module.exports = __webpack_public_path__ + "static/media/Joker2.1ba0f353.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Joker2.svg
// module id = 86
// module chunks = 0